import { _ as _object_spread } from "@swc/helpers/_/_object_spread";
import React from 'react';
import Close from '../../../../../Icons/16x16/Close';
import LargeInputIconButton from '../LargeInputIconButton';
const ClearButton = (props)=>{
    return(// No translations in da-ds, so hard coding the a11y label
    /*#__PURE__*/ React.createElement(LargeInputIconButton, _object_spread({
        "aria-label": "Clear",
        icon: Close,
        size: "small"
    }, props)));
};
ClearButton.displayName = 'ClearButton';
export default ClearButton;

//# sourceMappingURL=ClearButton.js.map